/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    OrgAdminSettingsDto,
    SegregationOfDutiesConflict,
    UpdatableOrgAdminSettings,
    UpdateControlPoliciesErrorPayload,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getOrganizationSettings = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<OrgAdminSettingsDto>> => {
    return axios.get(`/api/organization-settings`, options);
};

export const getGetOrganizationSettingsQueryKey = () => {
    return [`/api/organization-settings`] as const;
};

export const getGetOrganizationSettingsQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getOrganizationSettings>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getOrganizationSettings>>
    > = ({ signal }) => getOrganizationSettings({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSettingsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsQueryError = AxiosError<unknown>;

export function useGetOrganizationSettings<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOrganizationSettings>>,
                    TError,
                    Awaited<ReturnType<typeof getOrganizationSettings>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettings<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOrganizationSettings>>,
                    TError,
                    Awaited<ReturnType<typeof getOrganizationSettings>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettings<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrganizationSettings<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOrganizationSettingsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOrganizationSettingsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getOrganizationSettings>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getOrganizationSettings>>
    > = ({ signal }) => getOrganizationSettings({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSettingsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsSuspenseQueryError = AxiosError<unknown>;

export function useGetOrganizationSettingsSuspense<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettingsSuspense<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettingsSuspense<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrganizationSettingsSuspense<
    TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrganizationSettings>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetOrganizationSettingsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchOrganizationSettings = (
    updatableOrgAdminSettings: UpdatableOrgAdminSettings,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/organization-settings`,
        updatableOrgAdminSettings,
        options
    );
};

export const getPatchOrganizationSettingsMutationOptions = <
    TError = AxiosError<UpdateControlPoliciesErrorPayload>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchOrganizationSettings>>,
        TError,
        { data: UpdatableOrgAdminSettings },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchOrganizationSettings>>,
    TError,
    { data: UpdatableOrgAdminSettings },
    TContext
> => {
    const mutationKey = ["patchOrganizationSettings"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchOrganizationSettings>>,
        { data: UpdatableOrgAdminSettings }
    > = (props) => {
        const { data } = props ?? {};

        return patchOrganizationSettings(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchOrganizationSettingsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchOrganizationSettings>>
>;
export type PatchOrganizationSettingsMutationBody = UpdatableOrgAdminSettings;
export type PatchOrganizationSettingsMutationError =
    AxiosError<UpdateControlPoliciesErrorPayload>;

export const usePatchOrganizationSettings = <
    TError = AxiosError<UpdateControlPoliciesErrorPayload>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchOrganizationSettings>>,
            TError,
            { data: UpdatableOrgAdminSettings },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchOrganizationSettings>>,
    TError,
    { data: UpdatableOrgAdminSettings },
    TContext
> => {
    return useMutation(
        getPatchOrganizationSettingsMutationOptions(options),
        queryClient
    );
};
export const getOrganizationSettingsSegregationOfDutiesConflicts = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SegregationOfDutiesConflict[]>> => {
    return axios.get(
        `/api/organization-settings/segregation-of-duties-conflicts`,
        options
    );
};

export const getGetOrganizationSettingsSegregationOfDutiesConflictsQueryKey =
    () => {
        return [
            `/api/organization-settings/segregation-of-duties-conflicts`,
        ] as const;
    };

export const getGetOrganizationSettingsSegregationOfDutiesConflictsQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getOrganizationSettingsSegregationOfDutiesConflicts
            >
        >,
        TError = AxiosError<unknown>,
    >(options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetOrganizationSettingsSegregationOfDutiesConflictsQueryKey();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getOrganizationSettingsSegregationOfDutiesConflicts
                >
            >
        > = ({ signal }) =>
            getOrganizationSettingsSegregationOfDutiesConflicts({
                signal,
                ...axiosOptions,
            });

        return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getOrganizationSettingsSegregationOfDutiesConflicts
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetOrganizationSettingsSegregationOfDutiesConflictsQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getOrganizationSettingsSegregationOfDutiesConflicts
            >
        >
    >;
export type GetOrganizationSettingsSegregationOfDutiesConflictsQueryError =
    AxiosError<unknown>;

export function useGetOrganizationSettingsSegregationOfDutiesConflicts<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getOrganizationSettingsSegregationOfDutiesConflicts
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getOrganizationSettingsSegregationOfDutiesConflicts
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettingsSegregationOfDutiesConflicts<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getOrganizationSettingsSegregationOfDutiesConflicts
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getOrganizationSettingsSegregationOfDutiesConflicts
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettingsSegregationOfDutiesConflicts<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrganizationSettingsSegregationOfDutiesConflicts<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetOrganizationSettingsSegregationOfDutiesConflictsQueryOptions(
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOrganizationSettingsSegregationOfDutiesConflictsSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getOrganizationSettingsSegregationOfDutiesConflicts
            >
        >,
        TError = AxiosError<unknown>,
    >(options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetOrganizationSettingsSegregationOfDutiesConflictsQueryKey();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getOrganizationSettingsSegregationOfDutiesConflicts
                >
            >
        > = ({ signal }) =>
            getOrganizationSettingsSegregationOfDutiesConflicts({
                signal,
                ...axiosOptions,
            });

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getOrganizationSettingsSegregationOfDutiesConflicts
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetOrganizationSettingsSegregationOfDutiesConflictsSuspenseQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getOrganizationSettingsSegregationOfDutiesConflicts
            >
        >
    >;
export type GetOrganizationSettingsSegregationOfDutiesConflictsSuspenseQueryError =
    AxiosError<unknown>;

export function useGetOrganizationSettingsSegregationOfDutiesConflictsSuspense<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettingsSegregationOfDutiesConflictsSuspense<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettingsSegregationOfDutiesConflictsSuspense<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrganizationSettingsSegregationOfDutiesConflictsSuspense<
    TData = Awaited<
        ReturnType<typeof getOrganizationSettingsSegregationOfDutiesConflicts>
    >,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getOrganizationSettingsSegregationOfDutiesConflicts
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetOrganizationSettingsSegregationOfDutiesConflictsSuspenseQueryOptions(
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
